var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-in-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5 14.1667C5 14.4594 5 14.6058 5.01306 14.733C5.12146 15.7895 5.8855 16.6622 6.91838 16.9093C7.04279 16.939 7.18792 16.9584 7.47807 16.9971L12.9713 17.7295C14.535 17.938 15.3169 18.0423 15.9237 17.801C16.4565 17.5891 16.9002 17.2006 17.1806 16.7005C17.5 16.1309 17.5 15.3421 17.5 13.7646V6.2354C17.5 4.65786 17.5 3.8691 17.1806 3.29949C16.9002 2.79939 16.4565 2.41087 15.9237 2.19903C15.3169 1.95775 14.535 2.062 12.9713 2.27049L7.47807 3.00292C7.18788 3.04162 7.04279 3.06096 6.91838 3.09072C5.8855 3.3378 5.12145 4.21048 5.01306 5.26695C5 5.39421 5 5.54058 5 5.83333M10 6.66667L13.3333 10M13.3333 10L10 13.3333M13.3333 10H2.5",
    stroke: "#FF4405",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.236b3241debe24d3172f5c240695ecf3.svg";
export { ForwardRef as ReactComponent };